
import { Button, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import CalendarBlackIcon from '../../../../assets/svg/calendarBlack.svg';
import CalendarGrayIcon from '../../../../assets/svg/calendarGray.svg';
import ListBlackIcon from '../../../../assets/svg/listBlack.svg';
import ListGrayIcon from '../../../../assets/svg/menuGray.svg';

const buttonStyleActive = {
  textTransform: 'none',
  color: '#181818',
  padding: '7px 12px',
  fontFamily: 'Schibsted Grotesk',
  fontSize: '14px',
  fontWeight: 500,
  backgroundColor: '#FFFFFF',
  boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.24)',
  '&:hover': {
    backgroundColor: '#FFFFFF',
  },
};
const buttonStyleInactive = {
  textTransform: 'none',
  color: '#878787 ',
  padding: '7px 12px',
  fontFamily: 'Schibsted Grotesk',
  fontSize: '14px',
  fontWeight: 500,
  backgroundColor: 'transparent',
};

interface CompanyFilterButtonProps {
  setSelected: (value: string) => void;
  selected: string;
  refreshCalendarEvents: () => void;
}

const SwitchViewComponent = ({ selected, setSelected, refreshCalendarEvents }: CompanyFilterButtonProps) => {

  const switchListViewHandler = (value: string) => {
    setSelected(value);
    if (value === 'calendar')
      refreshCalendarEvents();
  };

  return (
    <Stack direction='row' gap={1}
      sx={{
        width: 'fit-content',
        padding: '4px',
        borderRadius: '6px',
        border: '1px solid #D6D6D6',
        boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.04)',
        backgroundColor: '#EEEEEE',
      }}>
      <Button
        sx={selected === 'list' ? buttonStyleActive : buttonStyleInactive}
        onClick={() => switchListViewHandler('list')}
        startIcon={selected === 'list' ?
          <img src={ListBlackIcon} alt='list view' />
          :
          <img src={ListGrayIcon} alt='list view' />
        }
      >
        <FormattedMessage defaultMessage='List view' />
      </Button>
      <Button
        sx={selected === 'calendar' ? buttonStyleActive : buttonStyleInactive}
        onClick={() => switchListViewHandler('calendar')}
        startIcon={selected === 'calendar' ?
          <img src={CalendarBlackIcon} alt='calendar view' />
          :
          <img src={CalendarGrayIcon} alt='calendar view' />
        }
      >
        <FormattedMessage defaultMessage='Calendar view' />
      </Button>

    </Stack>
  );
};

export default SwitchViewComponent;